import { render, staticRenderFns } from "./DeepLinkRedirect.vue?vue&type=template&id=2b141a36&scoped=true&"
import script from "./DeepLinkRedirect.vue?vue&type=script&lang=js&"
export * from "./DeepLinkRedirect.vue?vue&type=script&lang=js&"
import style0 from "./DeepLinkRedirect.vue?vue&type=style&index=0&id=2b141a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b141a36",
  null
  
)

export default component.exports